import { makeChartComp } from '../../util/makeChartComp';
var LiquidChart = makeChartComp('Liquid');
export default LiquidChart;
